<template>
  <div>
    <a-spin :spinning="spinning" tip="Loading...">
      <!-- 加入overfloa-x参数使得在窗口变化的时候, 图不会突出去, 然后在刷新时候,echarts的自适应会消掉这个滑轨 -->
      <div id="myvolChart" :style="{ height: '500px' }"></div>
      <ul>
        <!-- <li>
          Calculated by <a-tag color="pink">FindMarkers</a-tag>of Seurat
          package;
        </li>
        <li>
          PerturbDB's Default Cutoff: |Avg_log2FC| &gt;= 0.2, P-value &lt;=
          0.05;
        </li> -->
        <li>
          Summary:
          <span style="color: red">{{ this.upregulated }} </span> Up-regulated
          genes and
          <span style="color: blue">{{ this.downregulated }} </span>
          down-regulated genes
        </li>
      </ul>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "hello",
  data() {
    return {
      umap: null,
      upregulated: 0,
      downregulated: 0,
      spinning: true,
    };
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_volcano.php",
        {
          params: {
            datasetId: this.$route.query.datasetId,
            gene: this.$route.query.gene,
          },
        }
      )
      .then((response) => {
        this.umap = response.data;
        this.drawLine(this.umap["data"]);
        this.upregulated = this.umap["up"];
        this.downregulated = this.umap["down"];
        this.spinning = false;
      });
  },
  methods: {
    drawLine(umap) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("myvolChart"));
      // 绘制图表
      myChart.setOption({
        // title: { text: "vue中使用echarts进行绘制图" },
        // tooltip: {},
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            dataView: {},
            saveAsImage: {
              pixelRatio: 2,
            },
          },
        },
        // title: { text: "Umap" },
        // width: 400,
        // height: 300,
        // grid: {
        //   show: false, // 取消网格线显示
        // },
        xAxis: {
          title: {
            text: "Log2Foldchange",
          },
          // splitLine: {
          //   show: false,
          // },
        },
        yAxis: {
          title: {
            text: "-Log10(P-value)",
          },
          // splitLine: {
          //   show: false,
          // },
        },
        //tooltips
        tooltip: {
          formatter: function (params) {
            var value = params.data;
            var avgLog2FC = Number(value[0]).toFixed(2);
            return (
              '<div style="font-size: 16px;padding-bottom: 7px;margin-bottom: 7px;"> Gene: ' +
              value[3] +
              "<br />  Avg_log2FC :" +
              avgLog2FC
            );
          },
        },
        series: [
          {
            color: ["#AA4643", "#4572a7"],
            data: umap,
            itemStyle: {
              color: function (params) {
                return params.data[2];
              },
            },
            type: "scatter",
            symbolSize: 3,
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
